<template>
    <div class="BaseSet">
        <a-form-model :model="form" :rules="modleRules" labelAlign="right" ref="ruleForm" class="baseForm">
            <a-form-model-item label="产品服务" ref="name" prop="name" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                <a-input v-model="form.name" :maxLength="25" @change="e => form.name = e.target.value.replace(/\s*/g, '')"/>
            </a-form-model-item>
            <a-form-model-item label="服务类型" ref="type" prop="type" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                <a-radio-group v-model="form.type">
                    <a-radio :value="1">测评</a-radio>
                    <a-radio :value="2">训练</a-radio>
                    <a-radio :value="3">教学</a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="备注" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                <a-input v-model="form.remark" type="textarea" :maxLength="200"/>
            </a-form-model-item>
            <a-form-model-item label=" " :labelCol="{span: 4}" :wrapperCol="{span: 20}" class="btn">
                <a-button @click="close" style="margin-right:15px;">取消</a-button>
                <a-button type="primary" @click="onSubmit" :loading="loading">保存信息</a-button>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
export default {
    name:'BaseSet',
    data () {
        return {
            form:{
                name:'',
                type:1,
                remark:'',
            },
            type:'',
            modleRules:{
                name: [
                    { required: true, message: "请填写产品服务", trigger: "blur" },
                    {max: 25, message: '产品服务长度最大25 个字符', trigger: 'change'}
                ],
                type:[{ required: true, message: "请选择服务类型", trigger: "blur" }]
            },
            loading:false,
        }
    },
    created () {
        this.type = this.$route.query.type;
        if(this.type == 'edit'){
            this.getDetail();
        }
    },
    methods: {
        // 提交
        onSubmit(){
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if(this.type == 'add'){
                        this.addFunction()
                    }else{
                        this.editFunction()
                    }
                }
            })
        },
        // 添加
        addFunction(){
            this.loading = true
            this.$http.productServiceAdd(this.form)
            .then(res => {
                this.loading = false;
                this.$message.destroy()
                    this.$message.success(res.data.message)
                    this.$router.push('/content/ContentProductService')
               
                
            })
            .catch(err => {
                this.loading = false;
                this.$message.destroy()
                this.$message.error(res.data.message)
            })
        },
        // 编辑
        editFunction(){
            this.loading = true
            this.$http.productServiceEdit(this.form)
            .then(res => {
                this.loading = false;
                this.$message.destroy()
                    this.$message.success('修改成功');
                    this.$router.push('/content/ContentProductService');
               
                
            })
            .catch(err => {
                this.loading = false;
                this.$message.destroy();
                this.$message.error(res.data.message);
            })
        },
        // 获取详情
        getDetail(){
            let params = {
                id:this.$route.query.id
            }
            this.$http.productServiceDetail(params)
            .then(res => {
                    let data = res.data.data
                    for(let key in this.form){
                        for(let k in data){
                            if(key == k){
                                this.form[key] = data[key]
                            }
                        }
                    }
                    this.form.id = data.id
              
                
            })
            .catch(err => {
                this.$message.destroy()
                this.$message.error(res.data.message)
            })
        },
        // 取消
        close(){
            this.$router.push('/content/ContentProductService')
        },
    }
}
</script>

<style scoped lang="less">
.baseForm{
    width: 40%;
    margin:0 auto;
}
/deep/ .btn .ant-col-4{
    opacity: 0;
}
/deep/ .btn .ant-col-20{
    display: flex;
    justify-content: center;
}
</style>
